import { GeologyWikiOverview } from '~/components/wiki/GeologyWikiOverview';
import { useGeologyWikiDetailOutletContext } from '~/routes/wiki/geology/$wikiId';

export default function GeologyWikiDetailIndexRoute() {
  const { wikiPage } = useGeologyWikiDetailOutletContext();

  return <GeologyWikiOverview wikiPage={wikiPage} />;
}
